import { useQuery } from '@tanstack/react-query';
import { API } from '@/utils/API';
import type { ResourceActivity } from '@/types/resourceActivity';

const fetchStudyActivities = async (
  studyId: string
): Promise<ResourceActivity[]> => {
  const response = await API.authenticated.fetch(
    `/studies/${studyId}/activities`
  );

  if (!response.ok) {
    throw new Error('Failed to fetch study activities');
  }

  return response.json();
};

export const useStudyActivities = (studyId: string | null) => {
  const {
    data: activities = [],
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['study-activities', studyId],
    queryFn: () => fetchStudyActivities(studyId!),
    enabled: !!studyId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  return {
    activities,
    isLoading,
    error: error ? (error as Error).message : null,
    refetch,
  };
};
